module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/kyoto_sns_05-2009e3003701ce4a6725f8e2978056a5.jpg";